var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-collapse",
    {
      attrs: { accordion: "" },
      model: {
        value: _vm.active,
        callback: function ($$v) {
          _vm.active = $$v
        },
        expression: "active",
      },
    },
    _vm._l(_vm.items, function (item) {
      return _c("list-item", {
        key: item.id,
        attrs: { item: item, "is-selected": _vm.isSelected(item) },
        on: { select: _vm.onSelect },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }